<template>
    <about-us-header />
    <div class="reception animate__animated animate__fadeIn" style="animation-duration: 3s;">
        <div class="container">
            <div class="reception-head">
                <h1 class="reception-title">
                    {{ $t("reception.title") }}
                </h1>
                <p class="reception-subtitle">
                    {{ $t("reception.subtitle1") }}
                </p>
                <p class="reception-subtitle">
                    {{ $t("reception.subtitle2") }}
                </p>
            </div>

            <div class="reception-body">
                <p class="reception-intro">
                    {{ $t("reception.intro") }}
                </p>

                <ul class="reception-list">
                    <li class="reception-list__item">
                        <span class="reception-list__text">
                            <b>{{ $t("reception.whoLabel") }}</b>{{ $t("reception.whoValue") }}
                        </span>
                    </li>
                    <li class="reception-list__item">
                        <span class="reception-list__text">
                            <b>{{ $t("reception.formatLabel") }}</b>{{ $t("reception.formatValue") }}
                        </span>
                    </li>
                    <li class="reception-list__item">
                        <span class="reception-list__text">
                            <b>{{ $t("reception.frequencyLabel") }}</b>{{ $t("reception.frequencyValue") }}
                        </span>
                    </li>
                    <li class="reception-list__item">
                        <span class="reception-list__text">
                            <b>{{ $t("reception.timeLabel") }}</b>{{ $t("reception.timeValue") }}
                        </span>
                    </li>
                    <li class="reception-list__item">
                        <span class="reception-list__text">
                            <b>{{ $t("reception.scheduleLabel") }}</b>
                            <a :href="`/hours_${$i18n.locale}.pdf`" target="_blank" class="reception-link">
                                {{ $t("reception.scheduleValue") }}
                            </a>
                        </span>
                    </li>
                </ul>
            </div>

            <div class="reception-contact">
                <p class="reception-contact__title">
                    {{ $t("reception.contactTitle") }}
                </p>
                <div class="reception-contact__links">
                    <a class="reception-link" :href="'mailto:' + email">
                        <b>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-mail-icon lucide-mail">
                                <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
                                <rect x="2" y="4" width="20" height="16" rx="2" />
                            </svg>

                            {{ email }}
                        </b>
                    </a>
                    <a class="reception-link" :href="whatsappLink" target="_blank" rel="noopener">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            id="Logo-Whatsapp--Streamline-Ionic-Filled" height="24" width="24">
                            <path fill="currentColor" fill-rule="evenodd"
                                d="M20.3333 3.6578c-1.0872 -1.08775 -2.37885 -1.94975 -3.8006 -2.5363C15.111 0.53495 13.58725 0.2354 12.0493 0.24005 5.59495 0.24005 0.3408 5.468 0.33815 11.895c-0.00285 2.0465 0.53665 4.05725 1.56345 5.8275L0.24 23.76l6.20815 -1.62065c1.71835 0.93095 3.64205 1.41815 5.5965 1.4175h0.0047c6.4538 0 11.7075 -5.22845 11.7106 -11.655 0.0039 -1.53265 -0.297 -3.05085 -0.8853 -4.4662 -0.5883 -1.4153 -1.45215 -2.6995 -2.54135 -3.77785ZM12.04935 21.5897h-0.0042c-1.74225 0.0005 -3.45285 -0.46575 -4.9539 -1.35035l-0.35545 -0.21 -3.6839 0.9618 0.9833 -3.5747 -0.2315 -0.3675C2.8295 15.5066 2.31335 13.7193 2.3153 11.895c0 -5.34075 4.36855 -9.6862 9.7377 -9.6862 2.57565 -0.0046 5.04765 1.01405 6.8723 2.8319 1.82465 1.81785 2.8525 4.286 2.8575 6.86165 -0.00205 5.34135 -4.3685 9.68735 -9.73345 9.68735Zm5.3387 -7.255c-0.29245 -0.14595 -1.7325 -0.8505 -1.9992 -0.9476 -0.2667 -0.09715 -0.46355 -0.146 -0.65835 0.14595 -0.19475 0.29185 -0.756 0.945 -0.9266 1.14185 -0.17065 0.1969 -0.3413 0.2184 -0.63375 0.07245 -0.29235 -0.1459 -1.2358 -0.4531 -2.3535 -1.4453 -0.86995 -0.7723 -1.45685 -1.72565 -1.6275 -2.01705 -0.17065 -0.2914 -0.0184 -0.4494 0.12805 -0.5943 0.1318 -0.1307 0.29245 -0.3402 0.43895 -0.5103 0.14645 -0.17015 0.1953 -0.29195 0.2924 -0.48615 0.09715 -0.19425 0.0488 -0.3644 -0.02415 -0.50975 -0.07295 -0.14545 -0.65835 -1.57925 -0.90195 -2.1625 -0.23785 -0.56805 -0.4788 -0.4909 -0.65835 -0.4998 -0.17065 -0.0084 -0.36745 -0.0105 -0.56125 -0.0105 -0.14805 0.00385 -0.29375 0.03825 -0.428 0.1009 -0.13425 0.06265 -0.25405 0.1524 -0.35215 0.26345 -0.2682 0.2919 -1.02425 0.9975 -1.02425 2.4297s1.05005 2.8182 1.1949 3.0124c0.14495 0.1943 2.06325 3.13585 4.9985 4.3974 0.54505 0.23345 1.102 0.43815 1.6685 0.6132 0.70085 0.22155 1.33875 0.1906 1.8427 0.11555 0.5623 -0.0835 1.73255 -0.7046 1.9756 -1.38495 0.2431 -0.6804 0.2436 -1.26315 0.17065 -1.38445 -0.073 -0.1213 -0.2683 -0.19475 -0.56125 -0.3402Z"
                                clip-rule="evenodd" stroke-width="0.5">
                            </path>
                        </svg>
                        {{ whatsapp }}
                    </a>
                </div>
                <p class="reception-contact__note">
                    {{ $t("reception.note") }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import aboutUsHeader from "@/components/aboutUsHeader.vue";

export default {
    components: { aboutUsHeader },
    data() {
        return {
            email: "client.care@cic.kz",
            whatsapp: "+7 701 754 0430",
        };
    },
    computed: {
        whatsappLink() {
            return "https://wa.me/" + this.whatsapp.replace(/\D/g, "");
        },
    },
};
</script>

<style lang="scss" scoped>
@mixin fontStyle($family, $style, $weight, $size, $lheight, $color) {
    font-family: $family;
    font-style: normal;
    font-weight: $weight;
    font-size: $size;
    line-height: $lheight;
    color: $color;
}

@mixin mobile {
    @media (min-width: 320px) and (max-width: 425px) {
        @content;
    }
}

@mixin tablet {
    @media (min-width: 425px) and (max-width: 768px) {
        @content;
    }
}

@mixin tablet-1024 {
    @media (min-width: 768px) and (max-width: 1024px) {
        @content;
    }
}

@mixin desktop {
    @media (min-width: 1024px) and (max-width: 1440px) {
        @content;
    }
}

.reception {
    padding-bottom: 80px;

    &-head {
        padding-bottom: 40px;
    }

    &-title {
        @include fontStyle(Roboto, normal, 500, 42px, 58px, transparent);
        background: linear-gradient(90deg,
                #ff143f 0%,
                #c600dd 49.97%,
                #1b27ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: 0.03em;
        text-transform: uppercase;
        padding-top: 60px;
        padding-bottom: 25px;
    }

    &-subtitle {
        @include fontStyle(Roboto, normal, 500, 22px, 30px, #373737);
        margin-bottom: 6px;
    }

    &-intro {
        @include fontStyle(Roboto, normal, 300, 20px, 27px, #373737);
        padding-bottom: 25px;
    }

    &-list {
        padding-left: 24px;
        list-style: disc;

        &__item {
            display: list-item;
            margin-bottom: 16px;
        }

        &__icon {
            margin-right: 12px;
            font-size: 20px;
            line-height: 27px;
        }

        &__text {
            @include fontStyle(Roboto, normal, 300, 20px, 27px, #373737);

            b {
                font-weight: 600;
            }
        }
    }

    &-link {
        color: #c600dd;
        text-decoration: underline;
        font-weight: 500;
    }

    &-contact {
        margin-top: 40px;
        padding-top: 30px;
        border-top: 1px solid #efefef;

        &__title {
            @include fontStyle(Roboto, normal, 500, 22px, 30px, #373737);
            padding-bottom: 15px;
        }

        &__links {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding-bottom: 25px;

            a {
                @include fontStyle(Roboto, normal, 400, 20px, 27px, #c600dd);
            }
        }

        &__note {
            @include fontStyle(Roboto, normal, 300, 20px, 27px, #373737);
        }
    }

    @include mobile() {
        padding-bottom: 40px;

        &-title {
            font-size: 20px;
            line-height: 24px;
            padding-top: 30px;
            padding-bottom: 15px;
        }

        &-subtitle {
            font-size: 14px;
            line-height: 18px;
        }

        &-intro,
        &-list__text,
        &-contact__note {
            font-size: 14px;
            line-height: 18px;
        }

        &-list__icon {
            font-size: 16px;
            line-height: 18px;
        }

        &-contact__title {
            font-size: 15px;
            line-height: 20px;
        }

        &-contact__links a {
            font-size: 14px;
            line-height: 18px;
        }
    }

    @include tablet() {
        &-title {
            font-size: 22px;
            line-height: 26px;
            padding-top: 30px;
        }

        &-subtitle {
            font-size: 15px;
            line-height: 20px;
        }

        &-intro,
        &-list__text,
        &-contact__note {
            font-size: 15px;
            line-height: 20px;
        }
    }

    @include tablet-1024() {
        &-title {
            font-size: 28px;
            line-height: 34px;
        }

        &-subtitle,
        &-contact__title {
            font-size: 16px;
            line-height: 20px;
        }

        &-intro,
        &-list__text,
        &-contact__note,
        &-contact__links a {
            font-size: 16px;
            line-height: 22px;
        }
    }

    @include desktop() {
        &-title {
            font-size: 32px;
            line-height: 40px;
        }
    }
}
</style>
